import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const MODULES: Array<{
  num: string;
  title: string;
  subtitle: string;
  image?: string;
  imageAlt?: string;
}> = [{
  num: '01',
  title: 'Protocolo H.E.R. — Plan de 21 días',
  subtitle: 'Seguí el protocolo día por día, con la fase, el plato y la receta que corresponde a cada semana — sin tener que decidir qué hacer vos.'
}, {
  num: '02',
  title: 'Tracker Premium H.E.R. — 21 días',
  subtitle: 'Registrá cómo descansás, cómo te sentís y qué hábitos querés sostener para visualizar tu progreso durante las tres semanas.',
  image: 'https://cdn.magicpatterns.com/uploads/wUFbzMsAKZ8Pgeg2UUQJ92/image.png',
  imageAlt: 'Tracker Premium H.E.R. — seguimiento semanal de 21 días'
}, {
  num: '03',
  title: 'Noche en Calma — 7 noches de ritual',
  subtitle: 'Un ritual guiado para las noches en que cuesta desconectar, pensado para bajar el estado de alerta antes de dormir.'
}, {
  num: '04',
  title: 'H.E.R. Movement — 21 rutinas en casa',
  subtitle: 'Rutinas cortas para hacer en casa, sin equipamiento, adaptadas a cada semana del protocolo.'
}, {
  num: '05',
  title: 'Guía de compras Argentina + Meal Prep',
  subtitle: 'Qué comprar y cómo organizar la semana, con precios y productos que se consiguen en Argentina.'
}, {
  num: '06',
  title: 'Recetario H.E.R. — 63 recetas',
  subtitle: 'Organizá tus comidas con 63 recetas simples, pensadas para que comer mejor no dependa de improvisar todos los días.'
}];
const PHASE_H_PREVIEWS = [{
  num: '01',
  title: 'Fase H',
  subtitle: 'Conocé la estructura de la primera semana.',
  image: 'https://cdn.magicpatterns.com/uploads/h5xEKGBtmMR56BqVJVpB7o/image.png',
  imageAlt: 'Preview de Fase H del Protocolo H.E.R.'
}, {
  num: '02',
  title: 'Plato H.E.R.',
  subtitle: 'Una herramienta práctica para aplicar el método.',
  image: 'https://cdn.magicpatterns.com/uploads/1rA9Tm7Sag39dCi2aDxjDM/image.png',
  imageAlt: 'Preview de Plato H.E.R. del Protocolo H.E.R.'
}, {
  num: '03',
  title: 'Receta H.E.R.',
  subtitle: 'Un ejemplo de las recetas que vas a encontrar.',
  image: 'https://cdn.magicpatterns.com/uploads/jKwg59wztnqKwf9VGHSUNi/image.png',
  imageAlt: 'Preview de Receta H.E.R.'
}];
const MODULE_CONTENT_PREVIEWS: Record<number, {
  title: string;
  subtitle: string;
  image: string;
  imageAlt: string;
}> = {
  2: {
    title: 'Preview · Noche 01',
    subtitle: 'Un ejemplo de una de las 7 noches de ritual.',
    image: 'https://cdn.magicpatterns.com/uploads/henmqr8Y7MpAJyADaYpERD/image.png',
    imageAlt: 'Preview Noche 01 de Noche en Calma'
  },
  3: {
    title: 'Preview · Rutina 01',
    subtitle: 'Así se estructura una de las 21 rutinas en casa.',
    image: 'https://cdn.magicpatterns.com/uploads/cDPFvrVsrLi1iw4sHgGEG3/image.png',
    imageAlt: 'Preview Rutina 01 de H.E.R. Movement'
  },
  4: {
    title: 'Preview · Compras + Meal Prep',
    subtitle: 'Una muestra de cómo organizar tus compras y tu semana.',
    image: 'https://cdn.magicpatterns.com/uploads/sZz8hN9SCWgscmhNv5YSCm/image.png',
    imageAlt: 'Preview de Guía de compras Argentina y Meal Prep'
  }
};
export function ForWhoSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [openPreviewIndex, setOpenPreviewIndex] = useState<number | null>(null);
  const toggle = (i: number) => {
    setOpenIndex(prev => prev === i ? null : i);
    if (i !== 0) setOpenPreviewIndex(null);
  };
  const togglePreview = (i: number) => setOpenPreviewIndex(prev => prev === i ? null : i);
  return;
}